/** Page404 — Not-found / 404 fallback page with a "Go Home" action. */

import { Box, Button, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const Container = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  width: "100%",
  gap: "1.5rem",
  padding: "2rem"
});

const Page404: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("base");

  return (
    <Container role="alert">
      <Typography variant="h1Bold" color="text.primary">
        {t("eInvoicingApp.notFound.code")}
      </Typography>
      <Typography variant="h3" color="text.secondary">
        {t("eInvoicingApp.notFound.title")}
      </Typography>
      <Typography variant="bodyText" color="text.secondary" textAlign="center">
        {t("eInvoicingApp.notFound.description")}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate("/home")}
        aria-label={t("eInvoicingApp.goHome")}
      >
        {t("eInvoicingApp.goHome")}
      </Button>
    </Container>
  );
};

export default Page404;
